import React from 'react';

const HiddenPrices = ({ valuation, isFineProperty, bigDiffWithExpectation, confident }) => {
  if (!valuation) return null;

  const getMessageContent = () => {
    if (isFineProperty) {
      return {
        title: "Un bien unique mérite une expertise dédiée.",
        content: [
          "Les biens de cette valeur ne peuvent être estimés de façon fiable en ligne.",
          "Un expert spécialisé dans les biens haut de gamme prendra contact avec vous pour une estimation personnalisée."
        ]
      };
    }

    if (!isFineProperty && bigDiffWithExpectation) {
      return {
        title: "Votre projet mérite un échange approfondi.",
        content: [
          "Nous constatons un écart significatif entre vos attentes exprimées et les données actuelles du marché.",
          "Certains éléments spécifiques à votre bien dont nous n'avons pas connaissance peuvent influencer sa valeur.",
          "Un conseiller Hosman vous contactera rapidement pour affiner l'analyse et vous proposer une estimation personnalisée."
        ]
      };
    }

    if (!isFineProperty && !bigDiffWithExpectation && !confident) {
      return {
        title: "L'indice de confiance de cette estimation est trop faible.",
        content: [
          "Les données disponibles ne permettent pas de produire une estimation suffisamment précise en ligne.",
          "Un agent Hosman prendra contact avec vous afin de réaliser une évaluation personnalisée."
        ]
      };
    }

    return null;
  };

  const messageData = getMessageContent();

  if (!messageData) return null;

  return (
    <div className='flex flex-col gap-6 md:border md:border-ih-purple-30 md:p-8 rounded-3xl text-center' data-testid='HiddenPrices'>
      <p className='h2'>{messageData.title}</p>
      <div className='flex flex-col gap-2 text-lg'>
        {messageData.content.map((message, index) => (
          <p key={index}>{message}</p>
        ))}
      </div>
    </div>
  );
};

export default HiddenPrices;
